<template>
<div
  class="thank_you_message"
  v-if="show_thank_you"
>
  <div
      style="font-size: 20px; margin-bottom: 10px;"
  >
      {{message}}
  </div>
  <span v-if="end_with_thank_you">
    Thank you!
  </span>
</div>
</template>

<script>
export default {

    props: {
      payment: {
        type: Object,
        default: function() { return null; }
      },
    },

    methods: {
    },

    computed: {

      message() {
          if ( this.payment.state == 'ready-to-process' )
          {
              if ( this.payment.request.for_message )
              {
                  return 'Your payment information has been received.';
              }
              else
              {
                  return 'Your payment information has been received and will be processed shortly.';
              }
          }

          if ( this.payment.state == 'processed' && this.payment.processed_successfully == true )
          {
              if ( this.payment.request.for_message )
              {
                  return 'Your payment information has been received.';
              }
              else
              {
                  return 'Your card has been charged.';
              }
          }

          if ( this.payment.state == 'processed' && this.payment.processed_successfully == false )
          {
              if ( this.payment.request.for_message )
              {
                  return 'There was a problem with your payment information. Please contact us to make arrangements.';
              }
              else
              {
                  return 'There was a problem charging your card. Please contact us to make arrangements.';
              }
          }

            return '';
      },

      show_thank_you() {

        if ( this.payment == null ) return false;

        let ret = false;
        
        if ( this.payment.state == 'ready-to-process' ) ret = true;
        if ( this.payment.state == 'processed' ) ret = true;

        if ( ret && this.payment.request.url_thank_you != null )
        {
          document.location = this.payment.request.url_thank_you;

          return false; // stops the thank you from momentarily showing...
        }

        return ret;
      },

      end_with_thank_you() {
        if ( this.payment == null ) return false;
        
        if ( this.payment.state == 'ready-to-process' ) return true;
        if ( this.payment.state == 'processed' && this.payment.processed_successfully != false ) return true;

        return false;
      },
    },
}
</script>

<style lang="scss" scoped>

.thank_you_message
{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}

</style>